import { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useObjectContext } from '../hooks/useObjectContext';

interface ObjectFilterBarProps {
  children: ReactNode;
  isListEmpty?: boolean;
  hasActiveFilters?: boolean;
}

export function ObjectFilterBar({
  children,
  isListEmpty = false,
  hasActiveFilters = false,
}: ObjectFilterBarProps) {
  const { regionTargets } = useObjectContext();
  const isHiddenOnEmptyList = isListEmpty && !hasActiveFilters;

  if (!regionTargets.filterBar || isHiddenOnEmptyList) {
    return null;
  }

  return createPortal(children, regionTargets.filterBar);
}
